// @ts-strict-ignore
import { useMemo } from 'react'

import { useCart } from '@/entities/cart'

export const useGetCartItemsById = (productId: number, relatedId: number = null) => {
	const { products } = useCart()
	const correctCartItems = useMemo(
		() =>
			products?.find(({ ID, RELATED_PRODUCTS }) => productId === ID && (!relatedId || relatedId === RELATED_PRODUCTS)),
		[productId, relatedId, products]
	)

	return correctCartItems
}
